import type { Registry as Services } from '@ember/service';
import { tKey } from 'ember-intl';
import {
  isSameOrAfter,
  isSameOrAfterToday,
} from 'lumen/utils/dates/native-js-date-utils';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function getFormattedChange(
  changeValue: number | undefined | null,
  intl: Services['intl'],
) {
  if (changeValue === null || changeValue === undefined) {
    return intl.t(tKey('general.not_available_short'));
  }

  // Add a sign for strictly positive and negative values only
  return intl.formatNumber(changeValue, { signDisplay: 'exceptZero' });
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function getPositiveReferenceValuePercentage(
  changeValue: number | null | undefined,
  maxChange: number,
) {
  if (changeValue !== undefined && changeValue !== null && changeValue >= 0) {
    return Math.round((changeValue / maxChange) * 100);
  }

  return 0;
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function getNegativeReferenceValuePercentage(
  changeValue: number | null | undefined,
  maxChange: number,
) {
  if (changeValue !== undefined && changeValue !== null && changeValue < 0) {
    const percentage = Math.round(Math.abs((changeValue / maxChange) * 100));
    return Math.min(percentage, 100);
  }

  return 0;
}

/**
 * Determines if the API is aware of the reference QP
 * SWLY, SDLY, etc is recognised by the API
 * custom and PP is not
 * @param { string } reference : query param
 */
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function isAPIReference(reference: string) {
  return reference !== 'custom' && reference !== 'PP';
}

/**
 * Checks if the given date is the same or comes after the given extract date. If no extract date is given it will default to today.
 *
 * @param { string } date : A day to check, in YYYY-MM-DD notation.
 * @param { string } extractDate : The extract day to compare to, in YYYY-MM-DD notation.
 * @return { boolean } : True if the given date is same or after the extract date, otherwise false.
 */
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function isSameOrAfterExtractDate(
  date: Date | string,
  extractDate?: Date | string,
) {
  if (extractDate) {
    return isSameOrAfter(date, extractDate);
  }

  return isSameOrAfterToday(date);
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function getZoneStart(xValue: number) {
  // Get the previous day in milliseconds
  return xValue - 24 * 3600 * 1000;
}
